/*
 * @Author: lizhigang
 * @Date: 2025-12-25
 * @Company: www.smm.cn
 * @Description: 封装 message hook，支持自定义容器
 */
"use client"

import { useCallback, type ReactNode } from "react"
import { App } from "antd"

interface UseMessageOptions {
  schema?: "page" | "modal"
}

/**
 * 封装 message hook，使用 App.useApp() 获取 message 实例
 * 解决 Next.js App Router 中静态 message 无法获取 ConfigProvider 主题配置的问题
 */
export function useMessage({ schema = "modal" }: UseMessageOptions = {}) {
  const { message } = App.useApp()

  const showSuccess = useCallback(
    (content: string, options?: { duration?: number; onClose?: () => void }) => {
      message.success({
        className: "sign-in-api-toast",
        content,
        duration: options?.duration,
        onClose: options?.onClose,
        style: { marginTop: schema === "modal" ? 0 : 40 },
      })
    },
    [message, schema]
  )

  const showError = useCallback(
    (content: ReactNode) => {
      message.error({
        className: "sign-in-api-toast",
        content,
        style: { marginTop: schema === "modal" ? 0 : 40 },
      })
    },
    [message, schema]
  )

  return {
    message,
    showSuccess,
    showError,
  }
}
